import { clsx } from 'clsx';
import type { FieldDiff } from '@tailorcast/shared-types';

interface DiffViewerProps {
  fieldDiffs: FieldDiff[];
}

const changeColors: Record<string, string> = {
  insert: 'bg-green-50 border-green-200',
  delete: 'bg-red-50 border-red-200',
  modify: 'bg-yellow-50 border-yellow-200',
  unchanged: 'bg-gray-50 border-gray-200',
};

export function DiffViewer({ fieldDiffs }: DiffViewerProps) {
  if (fieldDiffs.length === 0) {
    return <div className="text-sm text-gray-500">No changes</div>;
  }

  return (
    <div className="space-y-2">
      {fieldDiffs.map((diff, idx) => (
        <div
          key={idx}
          className={clsx('border rounded-lg p-3 text-sm', changeColors[diff.changeType])}
        >
          <div className="flex items-center justify-between mb-1">
            <span className="font-medium text-gray-700">{diff.fieldName}</span>
            <span className="text-xs text-gray-500 capitalize">{diff.changeType}</span>
          </div>
          {diff.changeType !== 'insert' && diff.before && (
            <div className="text-red-700 text-xs bg-red-50 rounded p-1.5 mb-1 line-through">
              {diff.before}
            </div>
          )}
          {diff.changeType !== 'delete' && diff.after && (
            <div className="text-green-700 text-xs bg-green-50 rounded p-1.5">{diff.after}</div>
          )}
        </div>
      ))}
    </div>
  );
}
